import { useLinkedinRequestsSelectedStore } from "presentation/stores/use-linkedinrequests-selected-store";
import { useFilterLinkedinRequestsStore } from "presentation/stores/use-filter-linkedinrequests-store";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import LinkedinRequestsForm from "presentation/components/LinkedinRequests/LinkedinRequestsForm";

const HeaderLinkedinRequestsGrid: React.FC = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterLinkedinRequestsStore();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const clearFilter = () => {
    resetFilters();
    //setGlobalFilterValue("");
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setFilters({
        ...filters,
         query: {
           ...filters.query,
           value: globalFilterValue
         }
      });
    }
  };

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilterValue(e.target.value);
  };

  useEffect(() => {
    if (filters.query.value !== globalFilterValue) {
      setGlobalFilterValue(filters.query.value);
    }
  }, [filters]);

  const addLinkedinRequests = () => {
    setShowModal(true);
  };

  return (
    <div className="flex justify-content-between">

      <Dialog
        header="Criar Pesquisa LinkedIn"
        visible={showModal}
        onHide={() => setShowModal(false)}
        style={{ width: "70vw", maxHeight: "90vh" }}
        contentStyle={{ overflowY: "auto" }}
      >
        <LinkedinRequestsForm mode="create" onSuccess={() => setShowModal(false)} />
      </Dialog>

      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Procurar"
          />
        </IconField>
      </div>

      <div style={{ display: "flex" }}>
        <Button
          type="button"
          icon="pi pi-plus"
          label="Nova Pesquisa"
          outlined
          onClick={addLinkedinRequests}
          style={{
            backgroundColor: "#2196f3",
            color: "white",
            borderRadius: "8px",
          }}
        />

        <div style={{ width: "10px" }} />

        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};

export default HeaderLinkedinRequestsGrid;